import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { IStoreState } from "../initialStoreState";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { IOnboardingChecklist } from "./onboardingChecklist.types";

export const FETCH_ONBOARDING_CHECKLIST_PROGRESS =
  "FETCH_ONBOARDING_CHECKLIST_PROGRESS";
export const FETCH_ONBOARDING_CHECKLIST_SUCCESS =
  "FETCH_ONBOARDING_CHECKLIST_SUCCESS";
export const FETCH_ONBOARDING_CHECKLIST_FAILED =
  "FETCH_ONBOARDING_CHECKLIST_FAILED";

export const fetchOnboardingChecklistProgress = () =>
  action(FETCH_ONBOARDING_CHECKLIST_PROGRESS);
export const fetchOnboardingChecklistSuccess = (
  data: IOnboardingChecklist,
) => action(FETCH_ONBOARDING_CHECKLIST_SUCCESS, { data });
export const fetchOnboardingChecklistFailed = (error: string) =>
  action(FETCH_ONBOARDING_CHECKLIST_FAILED, { error });

/** Fetches the server-computed onboarding checklist for the current user. */
export const fetchOnboardingChecklistAsync =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    dispatch(fetchOnboardingChecklistProgress());
    try {
      const response = await api.get("/user/get-onboarding-checklist");
      dispatch(fetchOnboardingChecklistSuccess(response.data.data));
    } catch (err: any) {
      const message =
        err.response?.data?.message || "Failed to load onboarding checklist";
      dispatch(fetchOnboardingChecklistFailed(message));
      dispatch(
        showMessage({
          type: "error",
          message,
          displayAs: "snackbar",
        }),
      );
    }
  };

/**
 * Skips the onboarding checklist for the current user, then refreshes the
 * checklist so the UI reflects the new `SKIPPED` state.
 */
export const skipOnboardingChecklistAsync =
  (
    onCallback?: (success: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    dispatch(saveLoaderProgress());
    try {
      const res = await api.post("/user/skip-onboarding-checklist", {
        skip: true,
      });
      dispatch(
        showMessage({
          type: "success",
          message: res.data?.message || "Onboarding skipped",
          displayAs: "snackbar",
        }),
      );
      dispatch(fetchOnboardingChecklistAsync());
      onCallback?.(true);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message:
            err.response?.data?.message || "Failed to skip onboarding",
          displayAs: "snackbar",
        }),
      );
      onCallback?.(false);
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
